import { Pipe, PipeTransform } from '@angular/core';

/**
 * Angular pipe that replaces placeholders in a string with a provided value.
 *
 * Placeholders should be wrapped with `%`, e.g. `%name%`.
 *
 * ```html
 *   {{ 'Hello, %name%!' | replace:'name':'Alice' }}  // 'Hello, Alice!'
 *   {{ 'Total: %amount%' | replace:'amount':42 }}    // 'Total: 42'
 * ```
 */
@Pipe({
  name: 'replace'
})
export class ReplacePipe implements PipeTransform {

  /**
   * Replaces all instances of a placeholder in a string with the provided replacement value.
   *
   * @param value - The input string containing placeholders (e.g., 'Hello, %name%!').
   * @param placeholder - The placeholder name without `%` delimiters (e.g., 'name').
   * @param replacement - The value to replace the placeholder with (string or number).
   * @returns The modified string with placeholders replaced, or the original value if empty.
   */
  transform(value: string | undefined, placeholder: string, replacement: string | number): string | undefined {
    if (!value || !placeholder) {
      return value;
    }
    const regex = new RegExp(`%${placeholder}%`, 'g');
    return value.replace(regex, String(replacement));
  }

}
